import DatePicker from './src/picker/date-picker'


export default DatePicker



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/index.js